import axios from 'axios'
import qs from 'qs'
import { Toast } from 'mand-mobile'
import LoginService from '@/services/login'
import Cookie from '@/utils/cookie'
import Consts from '@/common/consts'
import CommonURL from '@/http/common/url'
import TbkURL from '@/http/tbk/url'
axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL = ''
const fetch = options => {
  const { method = 'get', data, url } = options
  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(`${url}${options.data ? `?${qs.stringify(options.data)}` : ''}`)
    case 'delete':
      return axios.delete(url, { data })
    case 'head':
      return axios.head(url, data)
    case 'post':
      return axios.post(url, data, {
        transformRequest: [
          function(data) {
            return qs.stringify(data)
          },
        ],
      })
    case 'put':
      return axios.put(url, data)
    case 'patch':
      return axios.patch(url, data)
    default:
      return axios(options)
  }
}
/**
 * 增加请求拦截器
 * @param {any} options
 * @returns
 */
axios.interceptors.request.use(
  function(options) {
    const token = Cookie.get(Consts.COOKIE_USER_TOKEN)
    if (options.method === 'post') {
      if (!options.data.token) {
        options.data = {
          ...options.data,
          token: token,
          platform: 'wap',
        }
      }
    } else if (options.method === 'get') {
      if (options.url.indexOf(`token=${token}`) === -1) {
        options.params = {
          token: token,
          platform: 'wap',
          ...options.params,
        }
      }
    }
    return options
  },
  function(error) {
    throw new Error(error.message)
  }
)
/**
 * 增加响应拦截器
 * @param {any} options
 * @returns
 */
axios.interceptors.response.use(
  function(options) {
    let u = options.config.url.split('?')[0]
    if (options.data.code === 1) {
      return options
    } else if (options.data.code === -1) {
      LoginService.autoLogin(true)
      throw new Error(options.data.msg)
    } else if (options.data.code === -2) {
      const params = qs.parse(options.config.url.split('?')[1])
      if (params && params.needAuthDialog && parseInt(params.needAuthDialog) === 1) {
        // 需要授权弹窗
        let curURL = options.config.url.split('?')[0]
        const isCheckBind = curURL === TbkURL.BIND_TB_CHECK // 返回-2时, 接口地址是否等于绑定淘宝信息的接口, 如果是, 说明是在当前页点击的某个操作, 则在弹窗授权时, 点取消按钮时,不用返回上一页, 不做任何操作
        LoginService.showTaobaoAuth(isCheckBind)
      }
      throw new Error(options.data.msg)
    } else {
      let errMsg = options.data.msg
      if (errMsg === '请在有效的分销商二级域名下注册') {
        errMsg = '推广码无效'
      }
      // 以下几个接口不输出toast提示
      const ignoreArr = [CommonURL.GET_SHORT_URL]
      if (ignoreArr.indexOf(u) === -1) {
        if (errMsg && errMsg !== '服务器异常') {
          Toast.failed(errMsg, 1500)
        }
      }
      throw new Error(errMsg)
    }
  },
  function(error) {
    throw new Error(error.message)
  }
)

/**
 * http异步请求
 * @export
 * @param {any} options
 * @returns
 */
export default async function http(options) {
  return fetch(options)
    .then(response => {
      return response
    })
    .catch(error => {
      throw new Error(error.message)
    })
}
